import { SxProps, TableCell, TableRow, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';

export type InformationTableRowProps = {
    cels: Array<ReactNode>;
    cellsSx?: SxProps[];
    bodyRowSxProps?: SxProps;
};

const getKeyFromIndex = (index: number, prefix: string) => `${prefix}-${index}`;
const getSxFromIndex = (index: number, cellsSx?: SxProps[]): SxProps | undefined => {
    if (cellsSx && cellsSx[index]) {
        return cellsSx[index] as SxProps;
    }
    return undefined;
};

export const InformationTableRow: React.FunctionComponent<InformationTableRowProps> = function (
    props,
) {
    const { cels, cellsSx, bodyRowSxProps } = props;
    const { palette } = useTheme();

    const baseCelSx = {
        padding: '4px 8px',
        minHeight: 'auto',
        height: 'auto',
        border: 'none',
        lineHeight: '1.8',
    };

    const bodyRowSx = {
        border: 'none',
        ...bodyRowSxProps,
    };

    const bodyCelSx: SxProps = {
        ...baseCelSx,
        fontWeight: '500',
        fontSize: '14px',
        verticalAlign: 'middle',
        backgroundColor: palette.background.default,
    };

    const firstBodyCelSx = {
        ...bodyCelSx,
        borderTopLeftRadius: '12px',
        borderBottomLeftRadius: '12px',
    };

    const lastBodyCelSx = {
        ...bodyCelSx,
        borderTopRightRadius: '12px',
        borderBottomRightRadius: '12px',
    };

    const items = cels.map((cel, celIndex) => {
        let sx = { ...bodyCelSx };

        if (celIndex === 0) {
            sx = { ...firstBodyCelSx };
        } else if (celIndex === cels.length - 1) {
            sx = { ...lastBodyCelSx };
        }
        if (cellsSx) {
            const cellPropsSx = getSxFromIndex(celIndex, cellsSx) as SxProps;
            sx = { ...sx, ...cellPropsSx };
        }

        return (
            <TableCell
                sx={sx}
                key={getKeyFromIndex(celIndex, 'cel')}
            >
                {cel}
            </TableCell>
        );
    });

    return <TableRow sx={bodyRowSx}>{items}</TableRow>;
};
